import { render, staticRenderFns } from "./awardList.vue?vue&type=template&id=5f873620&scoped=true"
import script from "./awardList.vue?vue&type=script&lang=js"
export * from "./awardList.vue?vue&type=script&lang=js"
import style0 from "./awardList.vue?vue&type=style&index=0&id=5f873620&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f873620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f873620')) {
      api.createRecord('5f873620', component.options)
    } else {
      api.reload('5f873620', component.options)
    }
    module.hot.accept("./awardList.vue?vue&type=template&id=5f873620&scoped=true", function () {
      api.rerender('5f873620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/audit_of_banquet_tables/form/components/awardList.vue"
export default component.exports